import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ROUTE_MAP } from 'consts/url';

import './apartmentTypeSelector.scss';
import { PageFilterCard } from 'components/FilterCard';
import { useTranslation } from 'react-i18next';

const APARTMENT_SELECT = [
  // {
  //   label: 'Căn hộ Studio',
  //   url: `/${ROUTE_MAP.interior.id}/studio/tong-quan`,
  //   id: `/${ROUTE_MAP.interior.id}/studio`,
  // },
  {
    label: 'one_bedroom_plus_long',
    url: `/${ROUTE_MAP.interior.id}/1pn-plus/tong-quan`,
    id: `/${ROUTE_MAP.interior.id}/1pn-plus`,
  },
  {
    label: 'two_bedroom_long',
    url: `/${ROUTE_MAP.interior.id}/2pn/tong-quan`,
    id: `/${ROUTE_MAP.interior.id}/2pn`,
  },
  {
    label: 'three_bedroom_long',
    url: `/${ROUTE_MAP.interior.id}/3pn/tong-quan`,
    id: `/${ROUTE_MAP.interior.id}/3pn`,
  },
];

const ApartmentTypeSelector = () => {
  const isDesktop = window.innerWidth > 1180;

  if (!isDesktop) {
    return (
      <div className="selector-mobile">
        <Content />
      </div>
    );
  }

  return (
    <PageFilterCard className="apartment-type-selector">
      <Content />
    </PageFilterCard>
  );
};

const Content = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname } = history.location;

  return (
    <div className="apartment-selector-content">
      {APARTMENT_SELECT.map(({ label, url, id }) => {
        const isActive = pathname.includes(id);

        return (
          <button
            key={url}
            onClick={() => history.push(`${url}`)}
            className={`apartment-option ${isActive ? 'active' : ''}`}
          >
            <span className="apartment-option-label">{t(label)}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ApartmentTypeSelector;
